import React from 'react';
import { Check, PhoneOff } from 'lucide-react';
import { ApptBadge } from './util';

// Tap clients to include/exclude them from the calling queue.
export const PickList = ({ items, picked, onToggle, onAll, onNone }) => (
  <div className="mt-4" data-testid="calling-pick-list">
    <div className="mb-2 flex items-center justify-between gap-2">
      <p className="text-[11px] font-black uppercase tracking-wider text-slate-500">Tap to choose who to call · {picked.size} of {items.length} selected</p>
      <div className="flex gap-3 text-xs font-bold">
        <button type="button" onClick={onAll} data-testid="calling-pick-all" className="text-indigo-700 hover:underline">Select all</button>
        <button type="button" onClick={onNone} data-testid="calling-pick-none" className="text-slate-500 hover:underline">Clear</button>
      </div>
    </div>
    <ul className="max-h-[45vh] space-y-1.5 overflow-y-auto pr-1">
      {items.map((i) => {
        const on = picked.has(i.key);
        return (
          <li key={i.key}>
            <button type="button" onClick={() => onToggle(i.key)} aria-pressed={on} data-testid={`calling-pick-${i.key}`} className={`flex w-full items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-colors ${on ? 'border-indigo-300 bg-indigo-50' : 'border-slate-200 bg-white opacity-70 hover:opacity-100'}`}>
              <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-md border-2 ${on ? 'border-indigo-600 bg-indigo-600 text-white' : 'border-slate-300 bg-white'}`}>{on && <Check className="h-4 w-4" strokeWidth={3} />}</span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-bold text-slate-900">{i.name}</span>
                <span className="block truncate text-xs text-slate-500">{i.status_label}</span>
              </span>
              {i.next_appointment_at && <ApptBadge at={i.next_appointment_at} />}
              {!i.has_mobile && <span className="inline-flex items-center gap-1 text-[10px] font-bold text-rose-600"><PhoneOff className="h-3 w-3" />No mobile</span>}
            </button>
          </li>
        );
      })}
    </ul>
  </div>
);
